import { TypedDocumentNode, gql } from '@apollo/client';
import { ComponentProps } from 'react';
import styled from 'styled-components';

import { LineupButtons } from 'components/lineup/LineupButtons';
import { isFixtureOpened } from 'lib/so5';

import { LiveLineupFooter } from '../LiveLineupFooter';
import { LineupFooter_so5LeaderboardContender } from './__generated__/index.graphql';

const Row = styled.div`
  min-height: calc(6 * var(--unit));
  background: var(--c-neutral-100);

  &:last-child {
    background: var(--c-neutral-200);
  }

  &.padded {
    display: flex;
    padding: var(--unit) var(--double-unit);
  }
`;

type Props = {
  so5LeaderboardContender?: LineupFooter_so5LeaderboardContender;
} & Pick<ComponentProps<typeof LineupButtons>, 'onLoadPreviousLineup'>;

export const LineupFooter = ({
  so5LeaderboardContender,
  onLoadPreviousLineup,
}: Props) => {
  const isUpcoming =
    so5LeaderboardContender &&
    isFixtureOpened(so5LeaderboardContender.so5Leaderboard.so5Fixture);
  const canCompose = so5LeaderboardContender?.so5Leaderboard?.canCompose?.value;

  return (
    <div>
      {!isUpcoming && (
        <Row className="padded">
          {so5LeaderboardContender && (
            <LiveLineupFooter
              so5LeaderboardContender={so5LeaderboardContender}
            />
          )}
        </Row>
      )}
      {canCompose && (
        <Row>
          <LineupButtons
            so5Leaderboard={so5LeaderboardContender.so5Leaderboard}
            so5Lineup={so5LeaderboardContender.so5Lineup}
            managerTeam={so5LeaderboardContender.managerTeam}
            onLoadPreviousLineup={onLoadPreviousLineup}
          />
        </Row>
      )}
    </div>
  );
};

LineupFooter.fragments = {
  so5LeaderboardContender: gql`
    fragment LineupFooter_so5LeaderboardContender on So5LeaderboardContender {
      slug
      so5Leaderboard {
        slug
        canCompose {
          value
        }
        so5Fixture {
          slug
          type
          ...isFixtureOpened_so5Fixture
        }
        ...LineupButtons_so5Leaderboard
      }
      so5Lineup {
        id
        ...LineupButtons_so5Lineup
      }
      managerTeam {
        id
        ...LineupButtons_managerTeam
      }
      ...LiveLineupFooter_so5LeaderboardContender
    }
    ${LineupButtons.fragments.so5Leaderboard}
    ${LineupButtons.fragments.so5Lineup}
    ${LineupButtons.fragments.managerTeam}
    ${LiveLineupFooter.fragments.so5LeaderboardContender}
    ${isFixtureOpened.fragments.so5Fixture}
  ` as TypedDocumentNode<LineupFooter_so5LeaderboardContender>,
};
